import { render, staticRenderFns } from "./OrdersArchive.vue?vue&type=template&id=6bcb9f36&"
import script from "./OrdersArchive.vue?vue&type=script&lang=js&"
export * from "./OrdersArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports